import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'secondary'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant
}

export default function Button({ variant = 'primary', className = '', ...props }: Props) {
  // Per request: no heavy black outline on focus/active.
  // inline-flex + whitespace-nowrap: header actions stay one line when the flex row would otherwise squeeze them.
  const base =
    'inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0'

  // Per request: buttons are white; in dark mode, text matches app background.
  // (Dark-mode text color is handled by CSS in src/index.css via .btn-primary)
  const styles =
    variant === 'primary'
      ? 'btn-primary bg-white border border-gray-200 hover:bg-gray-50'
      : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'

  return <button className={`${base} ${styles} ${className}`} {...props} />
}

